exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n/*.dropdown-menu inner show*/\n.cust-margin ul.dropdown-menu.inner{\n    margin-bottom :0px !important;\n}\n", ""]);

// exports
